<template>
  <div class="page-container">
    <div class="main">
      <!--      <div>-->
      <!--      <el-button type="primary" size="small"   class="custom-button" plain>卡组</el-button>-->

      <!--      </div>-->
      <page :url="url" :form="form" @select-data="handleSelectionChange" @refresh-card-group="selectCardGroup"
            ref="pageRef">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.keywords')">
            <el-input
                style="width: 300px"
                v-model="form.keyword"
                :placeholder="$t('message.input')"
                maxlength="40"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.status')">
            <el-select v-model="form.status" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option v-for="item in cardStatusList"
                         :key="item.value"
                         :label="$formatter.formatCardStatus(null, null, item.value, null)"
                         :value="item.value"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.cardType')">
            <el-select v-model="form.cardType" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option v-for="item in cardTypeList"
                         :key="item.value"
                         :label="item.name"
                         :value="item.value"/>
            </el-select>
          </el-form-item>

          <el-form-item
              :label="$t('text.upstream')"
              v-if="ROLE_TYPE.isManager()"
          >
            <el-select
                v-model="form.receiverCardOrganization"
                :placeholder="$t('message.chooseOne')"
                :disabled="ROLE_TYPE.isAgent()"
            >
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option v-for="item in cardUpstreamList"
                         :key="item.value"
                         :label="item.name"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
        </template>

        <template slot="pageHeader">
          <div style=" display: flex; justify-content: space-between;">
            <h1 style="display:inline-flex;"> {{ $t('text.card') }} </h1>

            <div style=" align-items:center; display:flex;">
              <el-button type="primary" @click="add" size="small" style=" width: 101px;height: 32px;"
              >{{ $t('text.createCard') }}
              </el-button>

              <el-dropdown type="primary" @command="joinCardGroup"
                           :disabled="this.multipleSelection.length === 0">
                <el-button type="primary" size="small"
                           style="height: 32px; display: flex; align-items: center; justify-content: center;"
                           :disabled="this.multipleSelection.length === 0">
                    <span>
                      {{ $t('text.addToDeck') }}
                    </span>
                  <span>
                  <i class="el-icon-arrow-down  el-icon--right" style="padding-bottom: 1px;"></i>
                  </span>
                </el-button>
                <el-dropdown-menu>
                  <el-dropdown-item
                      v-for="item in cardGroupList"
                      :key="item.value"
                      :command="item.value"
                      style="height: 32px;"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown type="primary" @command="editStatusManualSettlement"
                           :disabled="this.multipleSelection.length === 0">
                <el-button type="primary" size="small"
                           style="height: 32px; display: flex; align-items: center; justify-content: center;"
                           :disabled="this.multipleSelection.length === 0">
                  {{ $t('text.updateStatus') }}<i
                    class="el-icon-arrow-down el-icon--right" style="padding-bottom: 1px;"></i>
                </el-button>
                <template>
                  <el-dropdown-menu>
                    <el-dropdown-item
                        v-for="item in updateCardStatusList"
                        :key="item.value"
                        :command="item.value"
                    >
                      {{ $formatter.formatCardStatus(null, null, item.value, null) }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <el-button v-if="!ROLE_TYPE.isCustomerServiceStaff() && !ROLE_TYPE.isBusinessCustomerServiceManage()"
                         @click="exportDetail"
                         size="small"
                         type="primary"
                         style=" width: 101px;height: 32px;"
              >{{ $t('text.exportToExcel') }}
              </el-button>
              <el-button @click="popBatchbulkCardFile" size="small" style=" width: 101px;height: 32px;"
              >{{ $t('text.batchTransfer') }}
              </el-button>
            </div>
          </div>
        </template>

        <template slot="tableColumn">
          <el-table-column type="selection" width="50" align="left">
          </el-table-column>
          <el-table-column
              prop="status"
              width="80px"
              :label="$t('text.status')"
              fixed
              align="left"
          >
            <template slot-scope="scope">
              <el-tag size="medium"
                      :type="scope.row.status === '00'
                               ? 'info'
                               : scope.row.status === '02'
                               ? 'danger'
                               : scope.row.status === '03'
                               ? 'success'
                               : 'primary'">
                {{
                  scope.row.status === '00' ? $t('cardStatus.00') : (scope.row.status === '02' ? $t('cardStatus.02') : (scope.row.status === '03' ? $t('cardStatus.03') : $t('cardStatus.01')))
                }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
              width="180px"
              :label="$t('text.cardName')"
              fixed
              align="left"
              header-align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.receiverCardAccount + '-' + getCardTypeName(scope.row.cardType) }}
            </template>
          </el-table-column>

          <el-table-column
              width="240px"
              :label="$t('text.cardName') + '/' + $t('text.upstreamAbridge')"
              :render-header="renderheader"
              align="left"
              header-align="left"
          >
            <template slot-scope="scope">
              {{ getCardTypeName(scope.row.cardType) }}
              <div/>
              {{ getReceiverCardOrganizationName(scope.row.receiverCardOrganization) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="createTime"
              width="120px"
              :label="$t('text.creationTime')"
              :formatter="$formatter.formatDateToDate"
              align="left"
              header-align="left"
          >
          </el-table-column>

          <el-table-column
              prop="minAmount"
              width="120px"
              :label="$t('text.minAmount')"
              align="left"
              header-align="left"
          >
            <template slot-scope="{ row }">
              {{ $formatter.YuanToThousandth(null, null, row.minAmount, null) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="maxAmount"
              width="120px"
              :label="$t('text.maxAmount')"
              align="left"
              header-align="left"
          >
            <template slot-scope="{ row }">
              {{ $formatter.YuanToThousandth(null, null, row.maxAmount, null) }}
            </template>
          </el-table-column>

          <el-table-column prop="beenUsed"
                           width="260px"
                           :label="$t('text.availableAmount/Used')"
                           align="left"
                           header-align="left">
            <template slot-scope="{ row }">
              <div class="orderStyle" style="margin-bottom: 0" v-if="row.yearQuota && row.yearQuota>0">
                {{ $t('status.year') }} : {{ $formatter.YuanToThousandth(null, null, row.yearQuota, null) }} / <i
                  style="color:#67C23A">{{ $t('text.used') }}
                : {{ $formatter.YuanToThousandth(null, null, row.usedMonthQuota, null) }}</i>
              </div>
              <div class="orderStyle" style="margin-bottom: 0" v-if="row.monthQuota && row.monthQuota>0">
                {{ $t('status.month') }} : {{ $formatter.YuanToThousandth(null, null, row.monthQuota, null) }} / <i
                  style="color:#67C23A">{{ $t('text.used') }} :
                {{ $formatter.YuanToThousandth(null, null, row.usedMonthQuota, null) }}</i>
              </div>
              <div class="orderStyle" style="margin-bottom: 0" v-if="row.weekQuota && row.weekQuota>0">
                {{ $t('status.week') }} : {{ $formatter.YuanToThousandth(null, null, row.weekQuota, null) }} / <i
                  style="color:#67C23A">{{ $t('text.used') }}
                : {{ $formatter.YuanToThousandth(null, null, row.usedMonthQuota, null) }}</i>
              </div>
              <div class="orderStyle" style="margin-bottom: 0" v-if="row.dailyQuota && row.dailyQuota>0">
                {{ $t('status.day') }} : {{ $formatter.YuanToThousandth(null, null, row.dailyQuota, null) }} / <i
                  style="color:#67C23A">{{ $t('text.used') }} :
                {{ $formatter.YuanToThousandth(null, null, row.usedMonthQuota, null) }}</i>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="balance"
              width="160px"
              :label="$t('text.accountBalance')"
              sortable
              :sort-method="(a,b) => a.balance - b.balance"
              header-align="left"
              align="left"
          >
            <template slot-scope="{ row }">
              <el-button type="text" link @click="showAmountEdit(row)" style="color: black">
                <i class="el-icon-edit-outline" style="padding-right: 5px;"/>
              </el-button>
              {{ $formatter.FenToYuanToThousandth(null, null, row.balance, null) }}
            </template>
          </el-table-column>

          <el-table-column
              prop="cumulativeTransactionAmount"
              width="160px"
              :label="$t('text.totalTransactionAmount')"
              sortable
              :sort-method="(a,b) => a.cumulativeTransactionAmount - b.cumulativeTransactionAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              header-align="left"
              align="left"
          >
          </el-table-column>

          <el-table-column
              prop="remainingPercentage"
              width="160px"
              :label="$t('text.usedPercentage')"
              header-align="left"
              align="left"
          >
            <template slot-scope="{ row }">
              <div class="demo-progress">
                <el-progress
                    v-if="row.monthQuota > 0"
                    :percentage="getQuotaPercent(row.usedMonthQuota || 0, row.monthQuota)"/>
                <el-progress
                    v-else-if="row.dailyQuota > 0"
                    :percentage="getQuotaPercent(row.usedMonthQuota || 0, row.dailyQuota)"/>
                <el-progress
                    v-else-if="row.weekQuota > 0"
                    :percentage="getQuotaPercent(row.usedMonthQuota || 0, row.weekQuota)"/>
                <el-progress
                    v-else-if="row.yearQuota > 0"
                    :percentage="getQuotaPercent(row.usedMonthQuota || 0, row.yearQuota)"/>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="priority"
              width="80px"
              :label="$t('text.useWeight')"
              align="left"
          >
          </el-table-column>

          <el-table-column
              prop="receiverName"
              width="130px"
              :label="$t('text.cardholderName')"
              align="left"
              header-align="left"
          >
          </el-table-column>

          <el-table-column
              prop="receiverCardAccount"
              width="160px"
              :label="$t('text.accountNumber')"
              align="left"
              header-align="left"
          >
          </el-table-column>

          <el-table-column
              prop="deviceId"
              width="280px"
              :label="$t('text.deviceId')"
              align="left"
              header-align="left"
          >
          </el-table-column>
          <el-table-column
              prop="groupName"
              width="200px"
              :label="$t('text.cardGroupName')"
              align="left"
              header-align="left"
          >
          </el-table-column>

          <el-table-column fixed="right"
                           :label="$t('text.actions')"
                           :width="'240'"
                           align="center">
            <template slot-scope="scope">
              <el-button type="primary"
                         plain
                         size="mini"
                         @click="edit(scope.row)">
                {{ $t('text.edit') }}
              </el-button>

              <el-button type="success"
                         plain
                         size="mini"
                         @click="showLogDialog(scope.row)">
                {{ $t('text.log') }}
              </el-button>

              <el-button type="warning"
                         plain
                         size="mini"
                         @click="showCardTransactionFlow(scope.row)">
                {{ $t('text.anomalyRecord') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>

      <CardEditConfig
          v-if="isShowEditDialog"
          :show.sync="isShowEditDialog"
          :value="formData"
          :action="action"
          :channel-option="channelOption"
          :card-type-list="cardTypeList"
          @refresh-upstream-list="refreshUpstreamList"
          :card-upstream-list="cardUpstreamList"
          @refresh-card-list="refreshCrdList"
      ></CardEditConfig>

      <CardLogDialog
          v-if="isShowLogDialog"
          :isShowLogDialog.sync="isShowLogDialog"
          :logDialogValue="logDialogValue"
          :cardTypeList="cardTypeList"
      >
      </CardLogDialog>

      <CardAmountEdit
          v-if="isShowAmountEditDialog"
          :isShowAmountEditDialog.sync="isShowAmountEditDialog"
          :amountEditData="amountEditData"
          :cardTypeList="cardTypeList"
          @refresh-card-list="refreshCrdList"
      >
      </CardAmountEdit>

      <CardTransactionFlowDetails
          v-if="isShowCardTransactionFlowDialog"
          :isShowCardTransactionFlowDialog.sync="isShowCardTransactionFlowDialog"
          :cardTransactionFlowData="cardTransactionFlowData"
      >
      </CardTransactionFlowDetails>

      <input type="file"
             ref="bulkCardFile"
             class="file-input"
             @change="bulkCard"
             style="display: none"/>
    </div>
  </div>

</template>

<script>
import Page from "./CardGroupPage.vue";
import CardEditConfig from "./CardEditConfig.vue";
import CardLogDialog from "./CardLogDialog.vue";
import CardAmountEdit from "./CardAmountEdit.vue";
import CardTransactionFlowDetails from "./CardTransactionFlowDetails.vue";
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT, ROLE_TYPE
} from "@/utils/Constant";


export default {
  name: "Systems",
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE;
    }
  },
  components: {
    CardAmountEdit,
    CardTransactionFlowDetails,
    page: Page,
    CardEditConfig: CardEditConfig,
    CardLogDialog: CardLogDialog,
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      url: "/card/selectList",
      action: "",
      form: {
        keyword: "",
        status: "03",
        cardType: "",
        receiverCardOrganization: ""
      },
      logDialogValue: {},
      amountEditData: {},
      cardTransactionFlowData: {},
      multipleSelection: [],
      strMultipleSelection: [],
      isShowEditDialog: false,
      isShowLogDialog: false,
      isShowAmountEditDialog: false,
      isShowCardTransactionFlowDialog: false,
      formData: null,
      channelOption: [],
      cardTypeList: [],
      cardUpstreamList: [],
      cardGroupList: [],
      cardStatusList: [],
      updateCardStatusList: [],
      quotaList: [],
    };
  },
  created() {
    // 卡片类型
    this.$axios.get("/card/selectCardTypeOptions", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.cardTypeList = res.data;
      }
    });

    // 卡片状态
    this.$axios.get("/card/selectCardStatusOptions", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.cardStatusList = res.data;
        this.updateCardStatusList = res.data.filter(x => x.value !== "03");
      }
    });

    this.refreshUpstreamList();
    this.selectCardGroup()
  },
  methods: {
    edit(row) {
      this.action = "edit";
      this.isShowEditDialog = true;

      this.quotaList = [];
      if (row.yearQuota !== undefined && row.yearQuota !== null) {
        this.quotaList.push({
          quotaType: "yearQuota",
          quotaValue: row.yearQuota,
        });
      }

      if (row.monthQuota !== undefined && row.monthQuota !== null) {
        this.quotaList.push({
          quotaType: "monthQuota",
          quotaValue: row.monthQuota,
        });
      }

      if (row.weekQuota !== undefined && row.weekQuota !== null) {
        this.quotaList.push({
          quotaType: "weekQuota",
          quotaValue: row.weekQuota,
        });
      }

      if (row.dailyQuota !== undefined && row.dailyQuota !== null) {
        this.quotaList.push({
          quotaType: "dailyQuota",
          quotaValue: row.dailyQuota,
        });
      }
      row.quotaList = this.quotaList;
      this.formData = row;
    },
    add() {
      this.action = "add";
      this.isShowEditDialog = true;
    },
    editStatusManualSettlement(item) {

      const count = this.multipleSelection.length;
      const statusName = this.$formatter.formatCardStatus(null, null, this.cardStatusList.find((x) => x.value === item).value, null);

      const usingCount = this.multipleSelection.filter((x) => x.status === "03").length;
      const usingCardList = this.formatCardList(this.multipleSelection.filter((x) => x.status === "03"));

      const message = this.$t("text.confirmCardChange", {
        count,
        statusName,
        usingCount,
        usingCardList
      });

      this.$confirm(message,
          {
            dangerouslyUseHTMLString: true, // 关键：启用 HTML 渲染
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: 'warning',
          }
      ).then(() => {
        try {
          this.editStatus(item);
        } catch (error) {
          console.error('发生错误:', error); // 捕获潜在错误
        }
      })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('text.cancel'),
            });
          });
    },
    joinCardGroup(item) {
      this.$confirm(
          this.$t("text.confirmActionMessage"),
          this.$t("text.confirmActionTitle"),
          {
            dangerouslyUseHTMLString: true, // 关键：启用 HTML 渲染
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: 'warning',
          }
      ).then(() => {
        try {
          this.joinCardGroupMethod(item);
        } catch (error) {
          console.error('发生错误:', error); // 捕获潜在错误
        }
      })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t('text.cancel'),
            });
          });
    },
    editStatus(item) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning(this.$t('text.selectRow'));
        return;
      }

      const cardList = this.multipleSelection.map(item => Number(item.cardId));

      const requestBody = {
        status: item,
      };

      this.$axios
          .put('/card/batchUpdateCard', requestBody, {
            params: {
              cardIds: cardList.join(','),
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('text.operationSuccessful'));
              this.$refs.pageRef.showCardGroupInfo();
              this.$bus.$emit("refresh"); //通知刷新
            } else {
              this.$message.error(res.msg);
            }
          }).catch((error) => {
        console.error('请求失败:', error);
        this.$message.error(this.$t('text.operationFailed'));
      });
    },
    joinCardGroupMethod(item) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning(this.$t('text.selectRow'));
        return;
      }

      const cardList = this.multipleSelection.map(selection => Number(selection.cardId));

      const requestBody = {
        groupId: item,
      };

      this.$axios
          .put('/card/batchUpdateCard', requestBody, {
            params: {
              cardIds: cardList.join(','),
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('text.operationSuccessful'));
              this.$bus.$emit("refresh"); //通知刷新
              this.$refs.pageRef.showCardGroupInfo();

              this.$bus.$emit("refresh-list"); //通知刷新
            } else {
              this.$message.error(res.msg);
            }
          }).catch((error) => {
        console.error('请求失败:', error);
        this.$message.error(this.$t('text.operationFailed'));
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.strMultipleSelection = this.multipleSelection.map(
          ({orderId}) => orderId
      );
    },
    formatCardList(cards) {
      const uniqueCards = [
        ...new Set(
            cards.map((card) => `"${card.receiverCardAccount}-${card.upstream}"`)
        ),
      ];

      if (uniqueCards.length <= 3) {
        return uniqueCards.join('<br>');
      }

      return [
        uniqueCards[0],          // 第一笔
        uniqueCards[1],          // 第二笔
        '...',                   // 中间简略部分
        uniqueCards[uniqueCards.length - 1], // 最后一笔
      ].join('<br>');
    },
    getCardTypeName(value) {
      return this.cardTypeList.filter(x => x.value === value)[0].name;
    },
    getReceiverCardOrganizationName(value) {
      return this.cardUpstreamList.filter(x => x.value === value)[0].name;
    },
    getQuotaPercent(numerator, denominator) {
      if (!denominator || denominator <= 0) return 0
      const percent = (numerator / denominator) * 100
      return Math.min(Number(percent.toFixed(1)), 100)
    },
    selectCardGroup() {
      // 卡片组合
      this.$axios.get("/card-group/selectCardGroupOptions", {params: {}}).then((res) => {
        if (res.code === 200) {
          this.cardGroupList = res.data;
        }
      });
    },
    bulkCard() {
      const file = this.$refs.bulkCardFile;
      const formData = new FormData();
      formData.append("file", file.files[0]);
      this.axios
          .post("/card/importCards", formData, {
            transformRequest: [
              function (data, headers) {
                delete headers.post["Content-Type"];
                return data;
              }
            ]
          })
          .then((res) => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: "success"
              });
              file.value = "";
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            }
          })
          .catch((error) => {
            console.log(error);
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: res.msg
            });
            file.value = "";
          });
    },
    refreshCrdList() {
      this.$refs.pageRef.refreshCrdList();
      this.$refs.pageRef.selectCardGroup();
    },
    popBatchbulkCardFile() {
      this.$refs.bulkCardFile.click();
    },
    refreshUpstreamList() {
      // 卡片上游
      this.$axios.get("/card/selectCardOrganizationOptions", {params: {}}).then((res) => {
        if (res.code === 200) {
          this.cardUpstreamList = res.data;
        }
      });
    },
    renderheader(h, {column, $index}) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1])
      ]);
    },
    exportDetail() {
      this.axios
          .get("/card/selectListForExport", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.agentStatisticsExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              res
                  .text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
      });
    },
    showLogDialog(row) {
      this.isShowLogDialog = true;
      this.logDialogValue = row;
    },
    showAmountEdit(row) {
      this.isShowAmountEditDialog = true;
      this.amountEditData = row;
    },
    showCardTransactionFlow(row) {
      this.isShowCardTransactionFlowDialog = true;
      this.cardTransactionFlowData = row;
    }
  },
};
</script>

<style scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-popover pre {
  max-width: 800px;
  max-height: 500px;
  overflow: auto;
}

.el-dropdown {
  margin-left: 2px;
  margin-right: 2px;
}

.el-button {
  margin-left: 2px;
  margin-right: 2px;
}

.custom-button {
  z-index: 100; /* 设置优先级 */
  height: 100%; /* 父容器全高 */
}

</style>